import type { TasklistPageSubtask } from '@/types/tasklistPageJson';

export type ApiSubtaskCompletionRow = {
  subTaskId: number;
  completed: boolean;
  order?: number;
};

/**
 * Maps GET `/tasks` subtask rows (or legacy GET `/subtasks/.../tasks/{taskId}` rows) onto visible subtasks.
 * Uses {@link TasklistPageSubtask.subTaskId} when set, otherwise {@link TasklistPageSubtask.taskId}
 * (e.g. script-injected ids in `public/data/pages/*.json`), to match `apiRows[].subTaskId`.
 */
export function mergeSubtaskCompletionFromApi(
  allSubtasks: TasklistPageSubtask[],
  visibleSubtasks: TasklistPageSubtask[],
  apiRows: ApiSubtaskCompletionRow[]
): { subtasks: boolean[]; subTaskIds: number[] } {
  const byOrder = new Map<number, ApiSubtaskCompletionRow>();
  apiRows.forEach((row, i) => {
    const o = row.order ?? i;
    byOrder.set(o, row);
  });

  const subTaskIds: number[] = [];
  const subtasks: boolean[] = [];

  for (const st of visibleSubtasks) {
    const rowIdRaw = st.subTaskId ?? st.taskId;
    if (rowIdRaw != null && Number.isFinite(Number(rowIdRaw))) {
      const rowId = Number(rowIdRaw);
      const match = apiRows.find((r) => Number(r.subTaskId) === rowId);
      if (match) {
        subTaskIds.push(Number(match.subTaskId));
        subtasks.push(Boolean(match.completed));
        continue;
      }
    }
    const fullIdx = allSubtasks.indexOf(st);
    const row = byOrder.get(fullIdx) ?? apiRows[fullIdx];
    if (row && row.subTaskId != null) {
      subTaskIds.push(Number(row.subTaskId));
      subtasks.push(Boolean(row.completed));
    } else {
      subTaskIds.push(0);
      subtasks.push(false);
    }
  }
  return { subtasks, subTaskIds };
}
